import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'

import SearchTrendingDestinations from 'components/Search/SearchForm/SearchTrendingDestinations'
import ContactContext from 'contexts/contactContext'
import TextButton from 'components/Luxkit/Button/TextButton'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Heading from 'components/Luxkit/Typography/Heading'

const Section = styled.div`
  flex-direction: column;
  margin: ${rem(50)} 0 ${rem(50)};
  align-items: center;
`

const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

const Message = styled(BodyText)`
  margin: ${rem(8)} 0;
`

const ContactNumberLink = styled(TextLink)`
  margin-left: ${rem(4)};
`

const TrendingDestinationsSection = styled.div`
  display: flex;
  margin-top: ${rem(20)};
  width: 100%;
`

function HotelSearchNoSearchResultSection({ searchType }: {searchType?: App.SearchItem['searchType']}) {
  const currentContact = useContext(ContactContext)
  const localContact = currentContact.local

  return (
    <Section>
      <MessageBlock>
        <Heading variant="heading4">{searchType === 'property' ? "Sorry, we couldn't find this offer" : 'We couldn’t find any offers matching your search'}</Heading>
        <Message variant="large">
          <CSSBreakpoint min="tablet">
            Speak to one of our travel experts
            <ContactNumberLink href={`tel:${localContact.number}`} rel="nofollow">
              {localContact.humanReadable}
            </ContactNumberLink>
          </CSSBreakpoint>
          <CSSBreakpoint max="mobile">
            <TextButton startIcon={<LinePhoneIcon />} fit="mobile-full-width" kind="secondary" href={`tel:${localContact.number}`} rel="nofollow">Speak to a travel expert</TextButton>
          </CSSBreakpoint>
        </Message>
        <Message variant="large">
          <BodyText variant="medium">OR</BodyText>
        </Message>
        <Message variant="large">
          Explore our trending destinations
        </Message>
      </MessageBlock>
      <TrendingDestinationsSection>
        <SearchTrendingDestinations noTitle />
      </TrendingDestinationsSection>
    </Section>
  )
}

export default HotelSearchNoSearchResultSection
